import { Component, OnInit } from "@angular/core";
import { ModelService } from "../../../Services/model.service";
import { Customer } from "../../../Model/User/Customer";
import { LicenseService } from "../../../Services/license.service";
import { LicenseSelectEntry } from "../../../Model/User/LicenseSelectEntry";
import { TranslateService } from "@ngx-translate/core";
import {TranslatedText} from "../../../Model/ui/TranslatedText";

@Component({
    selector: "admin-accounts",
    templateUrl: "admin-accounts.component.html",
    standalone: false
})
export class AdminAccountsComponent implements OnInit {
  accounts: Customer[];
  licenses: LicenseSelectEntry[];
  accountTypes: TranslatedText [];
  consentAccountTypes: TranslatedText[];

  constructor(private modelService: ModelService, private licenseService: LicenseService, private translate: TranslateService) {
    this.reloadAccounts = this.reloadAccounts.bind(this);
  }

  ngOnInit(): void {
    if (this.modelService.loginService.currentUser == null) {
      this.modelService.router.navigate(["/"]);
      return;
    }
    if (!this.modelService.loginService.isAdmin) {
      this.modelService.router.navigate(["/"]);
      return;
    }

    this.licenseService.getLicenseSelectList().subscribe((licenses: LicenseSelectEntry[]) => {
      this.licenses = licenses;
    });

    
    this.accountTypes = [
       {value: "Unknown", translated: this.translate.instant("kein Hub-Account") },
      { value: "Dealer", translated: this.translate.instant("HändlerHub") },
      { value: "Manufacturer", translated: this.translate.instant("HerstellerHub") }
    ];

    this.consentAccountTypes = [
      { value: "Dealer", translated: this.translate.instant("Händler") },
      { value: "Manufacturer", translated: this.translate.instant("Hersteller") }
    ];

    this.getAccounts();
  }

  onGridToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'refreshButtonTemplate'
    });
  }

  getAccounts(): void {
    this.modelService.loginService.customerService.getAllCustomers().subscribe((result: Customer[]) => {
      this.accounts = result;
    });
  }

  reloadAccounts(): void {
    this.getAccounts();
  }
}
